/* tslint:disable */
import { Injectable } from '@angular/core';
import { Account } from '../../models/Account';
import { App } from '../../models/App';
import { Paastenant } from '../../models/Paastenant';
import { Apptype } from '../../models/Apptype';
import { Tenant } from '../../models/Tenant';
import { Counter } from '../../models/Counter';
import { Currency } from '../../models/Currency';
import { Metadata } from '../../models/Metadata';
import { Metadatahistory } from '../../models/Metadatahistory';
import { Metafield } from '../../models/Metafield';
import { Entity } from '../../models/Entity';
import { Menuitem } from '../../models/Menuitem';
import { Picklist } from '../../models/Picklist';
import { Picktable } from '../../models/Picktable';
import { Chart } from '../../models/Chart';
import { Formtemplate } from '../../models/Formtemplate';
import { Contact } from '../../models/Contact';
import { Entityfield } from '../../models/Entityfield';
import { Entityformula } from '../../models/Entityformula';
import { Entitypagelayout } from '../../models/Entitypagelayout';
import { Entitylistlayout } from '../../models/Entitylistlayout';
import { Entitycompactlayout } from '../../models/Entitycompactlayout';
import { Entityrecord } from '../../models/Entityrecord';
import { Entityrecordhistory } from '../../models/Entityrecordhistory';
import { Timeseries } from '../../models/Timeseries';
import { Installation } from '../../models/Installation';
import { Notification } from '../../models/Notification';
import { Profile } from '../../models/Profile';
import { Entitysearchlayout } from '../../models/Entitysearchlayout';
import { Dataelement } from '../../models/Dataelement';
import { Dashboard } from '../../models/Dashboard';
import { Activity } from '../../models/Activity';
import { Country } from '../../models/Country';
import { Timezone } from '../../models/Timezone';
import { Reporttemplate } from '../../models/Reporttemplate';
import { Reportdownload } from '../../models/Reportdownload';
import { Aggregates } from '../../models/Aggregates';
import { Note } from '../../models/Note';
import { Container } from '../../models/Container';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Account: Account,
    App: App,
    Paastenant: Paastenant,
    Apptype: Apptype,
    Tenant: Tenant,
    Counter: Counter,
    Currency: Currency,
    Metadata: Metadata,
    Metadatahistory: Metadatahistory,
    Metafield: Metafield,
    Entity: Entity,
    Menuitem: Menuitem,
    Picklist: Picklist,
    Picktable: Picktable,
    Chart: Chart,
    Formtemplate: Formtemplate,
    Contact: Contact,
    Entityfield: Entityfield,
    Entityformula: Entityformula,
    Entitypagelayout: Entitypagelayout,
    Entitylistlayout: Entitylistlayout,
    Entitycompactlayout: Entitycompactlayout,
    Entityrecord: Entityrecord,
    Entityrecordhistory: Entityrecordhistory,
    Timeseries: Timeseries,
    Installation: Installation,
    Notification: Notification,
    Profile: Profile,
    Entitysearchlayout: Entitysearchlayout,
    Dataelement: Dataelement,
    Dashboard: Dashboard,
    Activity: Activity,
    Country: Country,
    Timezone: Timezone,
    Reporttemplate: Reporttemplate,
    Reportdownload: Reportdownload,
    Aggregates: Aggregates,
    Note: Note,
    Container: Container,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/services/custom/SDKModels.ts